import { createSlice } from "@reduxjs/toolkit";

import ProfileSliceDto from "dto/redux/profile-slice-dto";

const initialState = {} as ProfileSliceDto;

export const profileSlice = createSlice({
	name: "profile",
	initialState,
	reducers: {
		updateProfile: (state, action) => {
			return Object.assign(state, action.payload);
		},
		resetProfile: () => initialState,
	},
});

export const { updateProfile, resetProfile } = profileSlice.actions;

export default profileSlice.reducer;
